const M = "h:mm A", T = "MM/DD/YYYY", A = `${T} ${M}`, _ = "YYYY-MM-DD", Y = "HH:mm:ss", O = `${_}T${Y}`, E = "YYYY-MM-DDTHH:mm:ss", s = "MM/YYYY", R = "ddd, MMM Do YYYY h:mm:ss A (z)";
export {
  Y as FULL_TIME_FORMAT,
  R as INFORMAL_DATE_TIME_FORMAT_WITH_TIMEZONE,
  _ as ISO_DATE_FORMAT,
  O as LOCAL_DATETIME_FORMAT,
  s as MONTH_YEAR_DATE_FORMAT,
  E as SERVICE_FORMAT,
  T as SHORT_DATE_FORMAT,
  A as SHORT_DATE_TIME_FORMAT,
  M as SHORT_TIME_FORMAT
};
//# sourceMappingURL=time.js.map
